import { Injectable, Inject, ReflectiveInjector } from "@angular/core";
import { DashboardConfigManager } from '../../services/dashboard.config.service';
import * as loggerColelction from '../../logger/index';
import { Logger } from '../../interfaces/logger.interface';

@Injectable()
export class LogService {


    private defaultLoggerName: string = "BrowserLogger";
    private loggerName: string;
    private logForInfo: boolean = true;
    private logForWarning: boolean = true;
    private logForError: boolean = true;
    private logger: Logger;

    constructor(private configService: DashboardConfigManager) {
    }

    public CreateLogger()
    {
        try{

            var mainlayout = this.configService.getDashboardLayout();
            var layout = mainlayout.logger;
            if (layout == null || typeof layout == "undefined") {
                this.loggerName = this.defaultLoggerName;
                this.logForInfo = true;
                this.logForError = true;
                this.logForWarning = true;
                console.log("Logger details were not found in config file, creating BrowserLogger!");
            }
            else {
                //set the logger related properties
                this.loggerName = (layout.loggerName!= "" || layout.loggerName != undefined ||  layout.loggerName== null) ?
                                    layout.loggerName : this.defaultLoggerName;
                this.logForInfo = (layout.turnOnInfoTrace != undefined) ? layout.turnOnInfoTrace : true;
                this.logForError = (layout.turnOnErrorTrace != undefined) ? layout.turnOnErrorTrace : true;
                this.logForWarning = (layout.turnOnWarningTrace != undefined) ? layout.turnOnWarningTrace : true;

            }
            //create injector
            var injector = ReflectiveInjector.resolveAndCreate([{ provide: "Logger", useClass: loggerColelction[this.loggerName] }]);

            if (injector) {
                //get the logger instace
                this.logger = injector.get("Logger")
                if (this.logger == undefined || !this.logger.loggerInitialized)// if logger is not init correctly 
                {
                    //fallback to base logger
                    this.loggerName = this.defaultLoggerName;
                    var injector = ReflectiveInjector.resolveAndCreate([{ provide: "Logger", useClass: loggerColelction[this.defaultLoggerName] }]);
                    if (injector) {
                        this.logger = injector.get("Logger");
                    }
                }
            }
            this.logInfo("LogService", "logger initialized. Logger Name: " + this.loggerName);
        }
        catch(error)
        {
            console.log("Logger details were not found in config file. Error is " + error);
        }
    }

    //log error
    public logError(source: string, message: string) {
        if (this.logForError && this.logger)
            this.logger.logError(source, message);
    }

    //log info
    //info logs will be logged only if the logInfoTrace flag is set to true in JSON file
    public logInfo(source: string, message: string) {
        if (this.logForInfo && this.logger)
            this.logger.logInfo(source, message);
    }

    //log warning
    public logWarning(source: string, message: string) {
        if (this.logForWarning && this.logger)
            this.logger.logWarning(source, message);
    }
}